// @avantia common-code
import { HpGetFeatureToggleAction } from '../actions/getFeatureToggleStateActionTypes';
import { HpEngineActionTypes } from '../types';
import { HpFeatureToggleMap, HpFeatureToggleState } from '../types/featureToggle';
import { getInitialState } from './initialState';
import { ReducerProcessor } from './reducerProcessor';

const processor = new ReducerProcessor<HpFeatureToggleState, HpEngineActionTypes>('FeatureToggle');

processor.add<HpGetFeatureToggleAction>('RETRIEVED_FEATURE_TOGGLE_STATE', (state, action) => {
  if (action.payload) {
    const { featureName, isEnabled } = action.payload || {};
    const newState: HpFeatureToggleMap = { ...state };
    newState[featureName] = isEnabled;
    return newState;
  }

  return state;
});

export function featureToggleReducer(
  state: HpFeatureToggleState = getInitialState().featureToggles,
  action: HpGetFeatureToggleAction
): HpFeatureToggleState {
  return processor.process(state, action);
}
